import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface AmountFieldProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  disabled?: boolean;
  maxValue: number;
}

const AmountField = ({
  value,
  onChange,
  disabled,
  maxValue,
}: AmountFieldProps) => {
  const { t } = useTranslation();
  const [raw, setRaw] = useState(value !== undefined ? String(value) : "");

  useEffect(() => {
    setRaw(value !== undefined ? String(value) : "");
  }, [value]);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    let v = e.target.value.replace(/[^\d.]/g, "");
    const parts = v.split(".");
    if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");
    const [intPart, decPart] = v.split(".");
    if (decPart && decPart.length > 2) v = `${intPart}.${decPart.slice(0, 2)}`;
    if (v !== "" && maxValue && Number(v) > maxValue) return;
    setRaw(v);
    onChange(v === "" ? undefined : Number(v));
  };

  const isFilled = raw.trim().length > 0;

  return (
    <div className={styles.field_group}>
      <div
        className={classNames(styles.floating_field, {
          [styles.is_filled]: isFilled,
          [styles.is_disabled]: disabled,
        })}>
        <input
          className={styles.floating_input}
          type="text"
          inputMode="decimal"
          value={raw}
          disabled={disabled}
          onChange={handleInput}
          placeholder=""
        />
        <label className={styles.floating_label}>{t("lbl_value")}</label>
        <span className={styles.sar}>{t("lbl_saudi_currency")}</span>
      </div>
    </div>
  );
};

export default AmountField;
